export const EASE = [0.22, 1, 0.36, 1];
export const DURATION = 0.6;
